import {ApiClient} from '@hconnect/apiclient'
import {useLoginContext, useUserContext} from '@hconnect/login'
import {Content, LandingPage, LoadingSwitcher} from '@hconnect/uikit/src/lib2'
import React, {useEffect} from 'react'
import {useLocation, useNavigate} from 'react-router'

import {getUrl, ROUTES} from '../../../routing'

type LoginGuardProps = {
  children: React.ReactNode
}

export const LoginGuard: React.FC<LoginGuardProps> = ({children}) => {
  const {isLoggedIn} = useLoginContext()
  const {loggedUser} = useUserContext()
  const navigate = useNavigate()
  const location = useLocation()
  const redirectToAuthenticator = () => ApiClient.loginFlow.startLoginProcess()

  useEffect(() => {
    if (/index.*?\.html/.exec(location.pathname)) {
      void navigate(getUrl(ROUTES.BASE.path, {}), {replace: true})
    }
  }, [location.pathname, navigate])

  if (!isLoggedIn) {
    return (
      <LandingPage
        onClickButton={() => void redirectToAuthenticator()}
        customLogoStyle={{
          height: '4rem'
        }}
      />
    )
  }

  return (
    <LoadingSwitcher variant="overlay" isLoading={loggedUser === null}>
      {loggedUser ? children : <Content style={{width: '100vw', height: '100vh'}} />}
    </LoadingSwitcher>
  )
}
